import Vue from 'vue'
import store from '../index'
import API from '../../../api'
const categoriesDefault = () => {
  return {
    inbox: 0,
    spam: 0,
    trash: 0
  }
}
export default {
  state: {
    categories: categoriesDefault(),
    messages: []
  },
  mutations: {
    messages(state, messages) {
      state.messages = messages
    },
    categories(state, categories) {
      state.categories = categories
    },
    readMessage(state, { uuid }) {
      const message = state.messages.find((message) => message.uuid === uuid)
      if (message) {
        Vue.set(message, 'is_read', true)
      }
    }
  },
  actions: {
    async messagesCount({ commit }, payload) {
      try {
        const categories = await API.messages.getMessagesCount(payload)
        commit('categories', categories)
        store.commit('setProjectSubmissionsCount', {
          ...payload,
          count: categories.inbox[1]
        })
      } catch (err) {
        commit('categories', categoriesDefault())
        throw err
      }
    },
    async messages({ commit }, payload) {
      try {
        const messages = await API.messages.getMessages(payload)
        commit('messages', messages)
      } catch (err) {
        commit('messages', [])
        throw err
      }
    }
  },
  getters: {
    messages(state) {
      return state.messages
    },
    categories(state) {
      return state.categories
    }
  }
}
